"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Methods_1 = __importDefault(require("./Methods"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var pay_api_1 = require("@l2p/pay-api");
var profile_api_1 = require("@l2p/profile-api");
var bank_transfer_1 = require("../icons/bank-transfer");
var cards_1 = require("../icons/cards");
var crypto_1 = require("../icons/crypto");
var paymentSystems_1 = require("../icons/paymentSystems");
var WithdrawalUnavailableCard_1 = require("./WithdrawalUnavailableCard");
var Withdrawal = function (_a) {
    var _b, _c, _d, _e;
    var methods = _a.methods, _f = _a.footerInsideInfo, footerInsideInfo = _f === void 0 ? false : _f, _g = _a.isModal, isModal = _g === void 0 ? false : _g;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _h = (0, react_1.useState)('cards'), method = _h[0], setMethod = _h[1];
    var _j = (0, swr_hooks_1.useAvailableWithdrawalBalance)(), data = _j.data, isLoading = _j.isLoading;
    var userBalance = (0, swr_hooks_1.useBalance)().data;
    var userData = (0, swr_hooks_1.useUser)().data;
    var METHODS_FILTERS = (0, react_1.useMemo)(function () { return ({
        cards: {
            label: t('cards'),
            Icon: cards_1.CardsIcon,
            stroke: true,
            key: 'cards',
        },
        'payment-systems': {
            label: t('paymentSystems'),
            Icon: paymentSystems_1.PaymentSystemsIcon,
            stroke: true,
            key: 'payment-systems',
        },
        crypto: {
            label: t('crypto'),
            Icon: crypto_1.CryptoIcon,
            stroke: true,
            key: 'crypto',
        },
        'bank-transfer': {
            label: t('bankTransfers'),
            Icon: bank_transfer_1.BankTransferIcon,
            stroke: true,
            key: 'bank-transfer',
        },
    }); }, [t]);
    var currentCurrency = ((_b = data === null || data === void 0 ? void 0 : data.balance) === null || _b === void 0 ? void 0 : _b.currency) || 'EUR';
    var methodsWithLabels = (0, react_1.useMemo)(function () {
        if (!(methods === null || methods === void 0 ? void 0 : methods.length))
            return [];
        return methods
            .filter(function (m) { return Boolean(METHODS_FILTERS[m.category]); })
            .map(function (m) { return (__assign(__assign({}, m), METHODS_FILTERS[m.category])); });
    }, [METHODS_FILTERS, methods]);
    var isIFrameMethod = methods === null || methods === void 0 ? void 0 : methods.find(function (m) { return m.redirectType === 'Frame'; });
    var currentMethod = (0, react_1.useMemo)(function () {
        if (!methodsWithLabels.length)
            return null;
        return (methodsWithLabels.find(function (m) { return m.slug === method; }) || (methodsWithLabels === null || methodsWithLabels === void 0 ? void 0 : methodsWithLabels[0]));
    }, [methodsWithLabels, method]);
    var currencySettings = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!currentMethod)
            return { min: 0, max: 0 };
        var minConstraints = (_a = currentMethod.constraints) === null || _a === void 0 ? void 0 : _a.find(function (c) { return (c === null || c === void 0 ? void 0 : c.type) === pay_api_1.PayOutConstraintType.MinTransaction; });
        var maxConstraints = (_b = currentMethod.constraints) === null || _b === void 0 ? void 0 : _b.find(function (c) { return (c === null || c === void 0 ? void 0 : c.type) === pay_api_1.PayOutConstraintType.MaxTransaction; });
        var min = (_d = (_c = minConstraints === null || minConstraints === void 0 ? void 0 : minConstraints.minTransaction) === null || _c === void 0 ? void 0 : _c.find(function (c) { return c.currency === currentCurrency; })) === null || _d === void 0 ? void 0 : _d.amount;
        var max = (_f = (_e = maxConstraints === null || maxConstraints === void 0 ? void 0 : maxConstraints.maxTransaction) === null || _e === void 0 ? void 0 : _e.find(function (c) { return c.currency === currentCurrency; })) === null || _f === void 0 ? void 0 : _f.amount;
        return {
            min: min || 0,
            max: max || 0,
        };
    }, [currentMethod, currentCurrency]);
    var freespins = (0, swr_hooks_1.useFreespins)(currentCurrency).data;
    var activeFreespins = (0, react_1.useMemo)(function () {
        return freespins === null || freespins === void 0 ? void 0 : freespins.find(function (bonus) { return bonus.status === profile_api_1.FreeRoundStatus.InProgress; });
    }, [freespins]);
    var realBalance = (0, react_1.useMemo)(function () { return +((userBalance === null || userBalance === void 0 ? void 0 : userBalance.amount) || 0); }, [userBalance]);
    var bonusBalance = (0, react_1.useMemo)(function () {
        return (Number(userBalance === null || userBalance === void 0 ? void 0 : userBalance.totalAmount) || 0) -
            (Number(userBalance === null || userBalance === void 0 ? void 0 : userBalance.amount) || 0);
    }, [userBalance]);
    var withdrawalBalance = (0, react_1.useMemo)(function () { var _a; return +(((_a = data === null || data === void 0 ? void 0 : data.balance) === null || _a === void 0 ? void 0 : _a.amount) || 0); }, [data]);
    var min = (0, react_1.useMemo)(function () { return +((currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min) || 0); }, [currencySettings]);
    var progress = (0, WithdrawalUnavailableCard_1.useProgress)({
        startWageringBalance: data === null || data === void 0 ? void 0 : data.startWageringBalance,
        wageringBalance: data === null || data === void 0 ? void 0 : data.wageringBalance,
        canWithdraw: data === null || data === void 0 ? void 0 : data.canWithdraw,
    });
    var showWithdrawalUnavailableCard = Boolean(data && !progress.hideWithdrawalUnavailableCard);
    if (isLoading || !(methods === null || methods === void 0 ? void 0 : methods.length) || !data) {
        return react_1.default.createElement("div", { className: styles_module_scss_1.default.loading },
            t('loading'),
            "...");
    }
    if (!currentMethod) {
        return react_1.default.createElement("div", { className: styles_module_scss_1.default.loading },
            t('loading'),
            "...");
    }
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.inner, !isIFrameMethod && styles_module_scss_1.default.notFrameInner) },
            react_1.default.createElement(Methods_1.default, { isIFrameMethod: isIFrameMethod, withdrawalBalance: withdrawalBalance, canWithdraw: (_c = data === null || data === void 0 ? void 0 : data.canWithdraw) !== null && _c !== void 0 ? _c : false, balance: data === null || data === void 0 ? void 0 : data.balance, user: (_e = (_d = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _d === void 0 ? void 0 : _d.getOne) === null || _e === void 0 ? void 0 : _e.profile, method: currentMethod, footerInsideInfo: footerInsideInfo, currencySettings: currencySettings, methodsWithLabels: methodsWithLabels, setMethod: setMethod, bonusBalance: bonusBalance, realBalance: realBalance, activeFreespins: activeFreespins, availableWithdrawalData: data, isModal: isModal, disabled: !progress.hideWithdrawalUnavailableCard, showWithdrawalUnavailableCard: showWithdrawalUnavailableCard }))));
};
exports.default = react_1.default.memo(Withdrawal);
